import React from 'react';
import type { LifecycleStep } from '../../threadSubject';

interface Props {
  steps: LifecycleStep[];
}

/**
 * The lifecycle stepper in the context rail (Decision 12): done is #10b981,
 * current is a #fb923c ring, todo is #444. A cancelled tail renders grey.
 */
export const LifecycleStepper: React.FC<Props> = ({ steps }) => (
  <ol className="lifecycle-stepper" aria-label="Progress">
    {steps.map((step, index) => (
      <li key={`${step.label}-${index}`} className={`lifecycle-step ${step.state}`} aria-current={step.state === 'current' ? 'step' : undefined}>
        <span className="lifecycle-dot" aria-hidden="true" />
        <span className="lifecycle-label">{step.label}</span>
      </li>
    ))}
  </ol>
);

export default LifecycleStepper;
